import api from "@/api";
import deepClone from "@/utils/deep-clone";

/**
 * STATE
 */
const state = {
    userList: [],
    analytics: {},
};

/**
 * GETTERS
 */
const getters = {
    userList(state) {
        return deepClone(state.userList) || [];
    },
    analytics(state) {
        return deepClone(state.analytics) || {};
    },
};

/**
 * ACTIONS
 */
const actions = {
    getUserlist({ commit }, { payload: { query = {} } }) {
        return api.post(`/api/feedback/stats/toplist`, query).then(({ data }) => {
            commit("setUserList", { userList: data });
        });
    },
    getAnalytics({ commit }, { payload: { query = {} } }) {
        return api.post(`/api/feedback/stats/totals`, query).then(({ data }) => {
            commit("setAnalytics", { analytics: data });
        });
    },
};

/**
 * MUTATIONS
 */
const mutations = {
    setUserList(state, { userList = [] } = {}) {
        state.userList = Object.freeze(userList);
    },
    setAnalytics(state, { analytics = {} } = {}) {
        state.analytics = Object.freeze(analytics);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
